/**
 * Redirects with a pause at the end so that form submission maintains isSubmitting state
 * until the redirect occurs.
 *
 * Normally, this isn't much of a problem but occasionally we see a few seconds on Chrome
 * where it can appear as though the page is not doing anything and we want to avoid the possibility of resubmitting data.
 */

export default async function redirectAsync(url) {
  // Use location.replace instead of location.assign to avoid having users get stuck by going back to a non-functional sign-in page
  // (have to get to the page via auth app or other flow)
  window.location.replace(url)
  // Pause here so that the browser never looks frozen (Chrome sometimes takes a few seconds to redirect)
  // Form submission will still show the submit button as submitting and disabled
  await new Promise((resolve) => {
    setTimeout(resolve, 10000)
  })
}
